import React, { useRef, useState } from "react";
import closeIcon from "../../../../assets/close.png";
import { login as cognitoLogin } from "@frontrunners/wl-cognito-login";
import { setCognitoTokens } from "../../../../common/authHelper";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import CustomButton from "../../../../common/CustomButton";
import "./PasswordModal.scss";

export const LoginConfirmationBox = ({ toggleLoginConfirmation, endpoints, password, setPassword }) => {
  const ref = useRef(null);
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const poolData = {
    UserPoolId: endpoints.cognitoUserPoolId,
    ClientId: endpoints.cognitoSupportalClientId,
  };

  useClickOutside(ref, () => toggleLoginConfirmation(false));

  const handleSubmit = () => {
    setErrorMessage("");
    setIsLoading(false);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrorMessage("Please enter a valid email address");
      return;
    }
    if (password.length < 3) {
      setErrorMessage("Password must be at least 3 characters long");
      return;
    }

    setIsLoading(true);
    const credentials = { username: email, password: password };
    cognitoLogin(poolData, credentials)
      .then((data) => {
        const token = data.idToken.jwtToken;
        setCognitoTokens(token, credentials.username);
        setErrorMessage("");
        setIsLoading(false);
        toggleLoginConfirmation(false);
      })
      .catch(() => {
        setErrorMessage("Cognito authentication failed. Please check your credentials.");
        setIsLoading(false);
      });
  };

  return (
    <div className="password-modal" ref={ref}>
      <div className="password-confirm">
        <div className="header">
          <h2>Login to Cognito</h2>
          <img src={closeIcon} alt="logo" className="close" onClick={() => toggleLoginConfirmation(false)} />
        </div>
        <p>Please authenticate with your Cognito credentials and then try again</p>
        <div className="password-box">
          <input
            className="new-input"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            value={email}
            style={{ marginBottom: "10px" }}
            disabled={isLoading}
          />
          <input
            className="new-input"
            style={{ marginBottom: 20 }}
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            value={password}
            disabled={isLoading}
          />
        </div>

        <CustomButton
          onClick={handleSubmit}
          disabled={!email || !password}
          loading={isLoading}
          variant="default"
          fullWidth
        >
          Login
        </CustomButton>
        {errorMessage && (
          <span style={{ color: "var(--color-error)", display: "block", marginTop: "10px" }}>{errorMessage}</span>
        )}
      </div>
    </div>
  );
};
